import React, { Component, Fragment } from 'react';
import { map, reduce } from 'lodash';
import { Icon } from 'semantic-ui-react';
import ReactHtmlParser from 'react-html-parser';
import * as Yup from 'yup';
import styled from 'styled-components';

import TextBlock from './components/textBlock';
import { newContentBlock } from '../forms/constants/eventContent';

const parseHtmlContent = (content) => {
  const regexImage = new RegExp('<img', 'gi');
  const res = content
    // .replace(/(width\s*=\s*["'](.*?)["'])/ig, 'width:auto')
    .replace(/(width\s*:\s*(.*?);)/ig, '')
    // .replace(/\s+style="[^"]*"/g, '')
    .replace(regexImage, '<img width:"auto" style="height: auto; display:block;"');
  return res;
};

const htmlHandler = (value) => {
  const data = [];
  value.forEach(element => {
    data.push({
      header: element.header,
      content: parseHtmlContent(element.content)
    });
  });
  return data;
};
// TODO MAKIMAKIMAKI remove style
export const ContentDisplay = ({ value }) => {
  const res = htmlHandler(value);

  return (
    <Fragment>
      { map(res, ({ header, content }, i) => (
        <div
          key={i}
          style={{ marginBottom: '20px' }}
          className='eventDetail_main_detail_block'
        >
          {header && (
            <Heading
              style={{ margin: '0 0 calc(8px + 2px)' }}
              className={`eventDetail_main_detail_heading${header ? '' : '-default'}`}
            >
              {header}
            </Heading>
          )}
          {
            header && header.toLowerCase().includes('sponsor') ? (
              <Fragment>
                {content && (
                  <SponsorContainer className='eventDetail_main_detail_content'>
                    {ReactHtmlParser(content)}
                  </SponsorContainer>
                )}
              </Fragment>
            ) : (
              <Fragment>
                {content && (
                <ContentContainer className='eventDetail_main_detail_content'>
                  {ReactHtmlParser(content)}
                </ContentContainer>
                  )}
              </Fragment>
              )
            }
        </div>
        ))
      }
    </Fragment>
  );
};


export const parseContent = (jsonString) => {
  try {
    const parsedContent = JSON.parse(jsonString);
    const schema = Yup.array().of(Yup.object().shape({
      header: Yup.string(),
      content: Yup.string()
    }));
    return schema.validateSync(parsedContent) ? parsedContent : [];
  } catch (e) {
    return [];
  }
};

class ContentEditor extends Component {
  onChange = (i, newBlock) => {
    const { value, onChange } = this.props;
    const blocks = reduce(
      value,
      (result, val, key) => {
        result.push(key === i ? newBlock : val);
        return result;
      },
      []
    );
    onChange(blocks);
  };

  render() {
    const {
      value, onAddNewBlock, onDeleteBlock, isPreview, maxImageSizeMB, fileType, userToken, slug
    } = this.props;
    return (
      <Fragment>
        {map(value, (block, i) => (
          <TextBlock
            key={i}
            block={block}
            onChange={(newBlock => this.onChange(i, newBlock))}
            onClickDeleteButton={((e) => {
              if (e) { e.preventDefault(); }
              onDeleteBlock(i);
            })}
            maxImageSizeMB={maxImageSizeMB}
            fileType={fileType}
            userToken={userToken}
            slug={slug}
          />
        ))}
        {(onAddNewBlock && !isPreview) && (
          <div
            className='eventDetail_main_detail_addButton'
            onClick={() => { onAddNewBlock(newContentBlock); }}
          >
            <Icon name='add' />
          </div>
        )}
      </Fragment>
    );
  }
}

const Heading = styled.h3`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
`;

const ContentContainer = styled.div`
div, p {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #667085;
}
`;

const SponsorContainer = styled(ContentContainer)`
  div, p {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    img {
      width: 124px;
      height: auto;
      margin: 1rem;
      object-fit: contain;
      display: inline-block;
    }
  }
`;

export default ContentEditor;



// WEBPACK FOOTER //
// ./src/components/contentEditor/index.js